import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid, Message, Checkbox } from 'semantic-ui-react'
import { savePartyDependency } from './actions/ValueBuildUp'

const ValueIndicator = ({ translate }) => {
    
    const dispatch = useDispatch()
    const partyDependency = useSelector(state => state.ValueBuildUpReducer.partyDependency) || []

    const changeHandler = (value, isChecked) => {
        dispatch({
            type:'UPDATE_PARTY_DEPENDENCIES',
            payload:{value, isChecked}
        })
        dispatch(savePartyDependency())
    }

    return (
      <div>
        <div style={{ textAlign: 'center' }}>
          {translate('4/13 VALUE INDICATOR', { ns: ['default', 'valueBuildUp'] })}
        </div>
        <Message className='ProrateWeight__content'>
          <div className='ProrateWeight__checkList'>
            <Grid>
              <Grid.Row>
                <Checkbox
                  type='checkbox'
                  name='H1'
                  label={
                    <label>
                      {translate('PARTY RELATIONSHIP, WHETHER THERE IS PRICE INFLUENCE OR NOT', {
                        ns: ['default', 'valueBuildUp'],
                      })}
                    </label>
                  }
                  value={'H1'}
                  checked={partyDependency.includes('H1')}
                  onClick={(e, data) => changeHandler(data.value, data.checked)}
                />
              </Grid.Row>
              <Grid.Row>
                <Checkbox
                  type='checkbox'
                  name='H4'
                  label={
                    <label>
                      {translate(
                        'RESTRICTION AS TO THE DISPOSAL OR USE OF GOODS BY THE BUYER IN ACCORDANCE WITH ARTICLE 70(3)(A) OF THE CODE',
                        {
                          ns: ['default', 'valueBuildUp'],
                        }
                      )}
                    </label>
                  }
                  value={'H4'}
                  checked={partyDependency?.includes('H4')}
                  onClick={(e, data) => changeHandler(data.value, data.checked)}
                />
              </Grid.Row>
              <Grid.Row>
                <Checkbox
                  type='checkbox'
                  name='H5'
                  label={
                    <label>
                      {translate(
                        'SALE OR PRICE SUBJECT TO SOME CONDITION OR CONSIDERATION IN ACCORDANCE WITH ARTICLE 70(3)(A) OF THE CODE',
                        {
                          ns: ['default', 'valueBuildUp'],
                        }
                      )}
                    </label>
                  }
                  value={'H5'}
                  checked={partyDependency?.includes('H5')}
                  onClick={(e, data) => changeHandler(data.value, data.checked)}
                />
              </Grid.Row>
              <Grid.Row>
                <Checkbox
                  type='checkbox'
                  name='I1'
                  label={
                    <label>
                      {translate(
                        'THE SALE IS SUBJECTED TO AN ARRANGEMENT UNDER WHICH PARTS OF THE PROCEEDS OF ANY SUBSEQUENT RESALE, DISPOSAL OR US DIRECTLY OR INDIRECTLY TO SELLERS',
                        { ns: ['default', 'valueBuildUp'] }
                      )}
                    </label>
                  }
                  value={'I1'}
                  checked={partyDependency?.includes('I1')}
                  onClick={(e, data) => changeHandler(data.value, data.checked)}
                />
              </Grid.Row>
            </Grid>
          </div>
        </Message>
      </div>
    )
}

export default ValueIndicator